import { Theme, CSSObject } from '@mui/material';

export default (theme: Theme): CSSObject => ({
  '&::-webkit-scrollbar': {
    width: theme.spacing(1),
    height: theme.spacing(1)
  },
  '&::-webkit-scrollbar-track': {
    borderRadius: 1,
    backgroundColor: 'grey.200'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 1,
    backgroundColor: 'grey.400'
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'grey.600'
  },
  '&::-webkit-scrollbar-thumb:active': {
    backgroundColor: 'text.secondary'
  }
});
